export const CustomBackstageTheme = {
    BackstageInfoCard: {
        styleOverrides: {
            headerTitle: {
                color: '#1351B4',
                fontSize: 18
            }
        }
    },
    BackstageTableToolbar: {
        styleOverrides: {
            title: {
                '& h2': {
                    fontSize: '18px !important'
                }
            },
        }
    },
    BackstageTableFilters: {
        styleOverrides: {
            filters: {
                display: 'flex',
                flexDirection: 'row'
            }
        }
    },
    BackstageSidebar: {
        styleOverrides: {
            drawer: {
                background: '#FFFFFF',
                boxShadow: '0 1px 6px 0 rgba(51, 51, 51, 0.16)',
                width: '256px !important',

            }
        }
    },
    BackstageSidebarPage: {
        styleOverrides: {
            root: {
                paddingLeft: '256px !important'
            }
        }
    },
    BackstageItemCardHeader: {
        styleOverrides: {
            root: {
                backgroundImage: 'url("/fundo_gov.png") !important',
                backgroundPosition: 'bottom'
            },
        }
    },
    BackstageSidebarDivider: {
        styleOverrides: {
            root: {}
        }
    },
    BackstageSidebarItem: {
        styleOverrides: {
            open: {
                width: '256px !important',
            },
            selected: {
                background: '#DBE8FB',
                fontWeight: 600,

                ":root": {
                    border: 'none'
                }
            },
            label: {
                color: '#1351B4',
                fontWeight: 400,
                fontSize: 14
            },
            iconContainer: {
                color: '#1351B4',
            },
            highlightable: {
                '&:hover': {
                    background: '#EEE'
                }
            },
            buttonItem: {
                color: '#1351B4',
                background: '#FFF',
                border: '1px solid #CCCCCC',

                '&:hover': {
                    background: '#EEE'
                }

            },
            closedItemIcon: {
                justifyContent: 'flex-end !important',
                paddingRight: 16
            }
        }
    },
    BackstageHeader: {
        styleOverrides: {
            header: () => ({
                width: 'auto',
                height: 92,
                boxShadow: 'none',
                backgroundImage: 'none',
                background: '#071D41'
            }),
            title: () => ({
                fontSize: 20,
                fontWeight: 500
            })
        },
    }
} 